<template>
    <v-layout wrap class="profile__achievments">
        <v-layout class="profile__achievments-item align-center">
            <companyProfileStat :text="$t('Рейтинг организации')" :number="company_page.rating || 0" class="mx-3" />
        </v-layout>
        <!-- {{ active_type.icon }} -->
      <v-layout class="profile__achievments-item align-center">
        <div class="grey-text ml-4">{{$t("Уровень")}}:</div>
        <v-flex class="ml-2">{{ $route.params.id ? company_page.level : company_info.level }}</v-flex>
      </v-layout>
        <v-layout v-if="active_type || other_active_type" class="profile__achievments-item align-center">
            <iconWithLabel :icon_name="$route.params.id ? other_active_type.icon : active_type.icon" class="mx-4 no_pointer" size="20">{{ $route.params.id ? other_active_type.type : active_type.type }}</iconWithLabel>
        </v-layout>
        <v-layout class="profile__achievments-item align-center">
            <div class="grey-text ml-4">{{$t("Дата регистрации")}}:</div>
            <v-flex class="ml-2">{{ $route.params.id ? company_page.register_date : company_info.register_date }}</v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import companyProfileStat from '@/components/view_blocks/Company_profile/Company_profile_info/Company_profile_stat';
import iconWithLabel from '@/components/ui/icons/icon_with_label';
import {mapGetters} from 'vuex';

export default {
  components: {
    companyProfileStat,
    iconWithLabel,
  },
  props: {
    company_page: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('company_profile/info', ['company_info', 'active_type']),
    ...mapGetters('company_profile', ['other_active_type']),
  },
  methods: {

  }
};
</script>

